module.exports = __webpack_public_path__ + "img/Pic-2.7eac5585.png";